module.exports = __webpack_public_path__ + "img/bh.1c15ad1a.png";